<template>
  <div class="map-content">
    <v-btn class="map-content__close-button" dark icon @click="onClose">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-btn v-if="isShowSetButton" depressed class="map-content__set-button" @click="onSubmit">설정하기</v-btn>
    <div class="box1">
      <v-text-field
        v-model="searchText"
        label="정류장이름 검색"
        @keyup.enter="onEnterSubway"
        hide-details/>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(subwayStation, i) in (this.subway || [])
          .filter(x => {
            var center = x[1] === '수도권'
            if (this.searchText === '') {
              return center
            } else {
              var inc = x[0].includes(this.searchText)
              return center && inc
            }
          })
          .sort(function(a, b) {
            if (a[4] === b[4]) {
              return 0
            } else {
              return a[4] < b[4] ? -1 : 1
            }
          })"
          :key="i"
          inactive
          class="content-checkbox__item"
          :ripple="false"
          style="padding-left: 0; padding-right: 0">
          <v-btn @click="onMoveSubwayStation(subwayStation)" text style="margin-left: 0; width: 100%">
            <div v-if="subwayStation[4].startsWith('1')" class="rounded-pill blue darken-2 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('2')" class="rounded-pill green lighten-1 d-inline-block white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('3')" class="rounded-pill orange lighten-1" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('4')" class="rounded-pill light-blue accent-2 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('5')" class="rounded-pill deep-purple accent-1 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('6')" class="rounded-pill brown lighten-2 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('7')" class="rounded-pill lime darken-3 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('8')" class="rounded-pill pink lighten-2 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else-if="subwayStation[4].startsWith('9')" class="rounded-pill brown lighten-5" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div v-else class="rounded-pill grey lighten-1 white--text" style="padding-left: 4px; padding-right: 4px; margin-right: 8px">{{ subwayStation[4] }}</div>
            <div style="width: 100%">
            {{ subwayStation[0] }}
            </div>
          </v-btn>
        </v-list-item>
      </v-list-item-group>
    </div>
    <div class="box2">
      <naver-maps
        :width=1000
        :height="800"
        :mapOptions="mapOptions"
        :initLayers="['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT']"
        @load="onLoad"
        class="map__content">
      </naver-maps>
    </div>
  </div>
</template>

<script>
import subway from '@/assets/model/subway.json'

export default {
  name: 'MapPick',
  props: {
    locationData: {
      type: Object,
      default: () => {}
    },
    isShowSetButton: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      mapOptions: {
        lat: 37.4788755,
        lng: 127.1271389,
        zoom: 17,
        zoomControl: true,
        zoomControlOptions: { position: 'TOP_LEFT' },
        mapTypeControl: true
      },
      vuemap: undefined,
      searchText: '',
      location: this.locationData,
      subway: subway
    }
  },
  methods: {
    onEnterSubway () {
      var list = this.subway.filter(x => {
        var center = x[1] === '수도권'
        if (this.searchText === '') {
          return center
        } else {
          var inc = x[0].includes(this.searchText)
          return center && inc
        }
      }).sort(function (a, b) {
        if (a[4] === b[4]) {
          return 0
        } else {
          return a[4] < b[4] ? -1 : 1
        }
      })
      if (list.length !== 0) {
        if (this.vuemap !== undefined) {
          const point = new window.naver.maps.LatLng(list[0][2], list[0][3])
          this.vuemap.setCenter(point)
        }
      }
    },
    onMoveSubwayStation (subwayStation) {
      if (this.vuemap !== undefined) {
        const point = new window.naver.maps.LatLng(subwayStation[2], subwayStation[3])
        this.vuemap.setCenter(point)
      }
    },
    onLoad (vue) {
      let marker

      // 시작 포지션
      if (this.locationData) {
        const point = new window.naver.maps.LatLng(this.locationData.lat, this.locationData.lng)
        vue.map.setCenter(point)
        marker = new window.naver.maps.Marker({
          map: vue.map,
          position: point
        })
      }
      this.vuemap = vue.map

      // 맵 클릭시 마커찍기
      window.naver.maps.Event.addListener(vue.map, 'click', (e) => {
        const point = e.coord
        this.location = {
          lat: point.y,
          lng: point.x
        }
        if (marker) {
          marker.setMap(null)
        }
        marker = new window.naver.maps.Marker({
          map: vue.map,
          position: point
        })
      })
    },
    onClose () {
      this.$emit('closeModal')
    },
    onSubmit () {
      this.$emit('onSubmitMapPick', this.location, this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.box1 {
  float: left;
  width: 200px;
  height: 800px;
}

.v-list-item-group {
  height:800px;/* or any height you want */
  overflow-y:scroll;
}

.box2 {
  width: 1000px;
  height: 800px;
  margin-left: 200px;
}

.map-content {
  width: 100%;
  height: 100%;

  &__close-button {
    position: absolute;
    right: 7px;
    top: 14px;
    color: #fff;
  }

  &__set-button {
    position: absolute;
    top: 14px;
    right: 80px;
  }
}

.map__content {
  margin: 0 auto;
}

.rounded-circle {
  border-radius:50px;
}

.content-checkbox__item {
  margin-top: 1px;
  display: flex;
  flex-direction: column;
  align-content: start;
  align-items: start;
  min-height: 0;
}
</style>
